class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);

        setTimeout(() => {
          this.close()
        }, 5000);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.notificationCartFD(parsedState);
    /* this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    if (this.header) this.header.reveal();
    this.open(); */
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  
  notificationCartFD(detail){
    const productImg = detail.image;
    const productTitle = detail.title;
    const cartNotificationProduct = document.getElementById('cart-notification-product');
    const cartBasket = document.getElementById('cart-icon-bubble'); 
    // Vaciar el contenido del elemento
    cartNotificationProduct.innerHTML = '';
    // Agregar la imagen del producto
    const productImageDiv = document.createElement('div');
    productImageDiv.classList.add('cart-notification-product__image', 'global-media-settings');
    const productImage = document.createElement('img');
    productImage.setAttribute('src', productImg);
    productImage.setAttribute('alt', productTitle);
    productImage.setAttribute('width', '70');
    productImage.setAttribute('height', '70');
    productImage.setAttribute('loading', 'lazy');
    productImageDiv.appendChild(productImage);
    cartNotificationProduct.appendChild(productImageDiv);
    // Agregar el nombre del producto
    const productNameDiv = document.createElement('div');
    const productTitleElement = document.createElement('h3');
    productTitleElement.classList.add('cart-notification-product__name', 'h4');
    productTitleElement.textContent = productTitle;
    productNameDiv.appendChild(productTitleElement);
    cartNotificationProduct.appendChild(productNameDiv);
    // Activar la notificación del carrito
    const cartNotification = document.getElementById('cart-notification');
    cartNotification.classList.add('active');
    // Desactivar la notificación después de 5 segundos
    setTimeout(() => {
        cartNotification.classList.remove('active');
    }, 5000);
    // Refrescar cantidad del carrito
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const itemCount = cart.item_count; // Obtén el total de artículos del carrito
            
            // Intentar encontrar el contador en el DOM
            let cartCountBubble = document.querySelector("#cart-icon-bubble .cart-count-bubble");
            
            // Si no existe, crearlo
            if (!cartCountBubble) {
                cartCountBubble = document.createElement('div');
                cartCountBubble.classList.add('cart-count-bubble');
                
                const cartCountVisible = document.createElement('span');
                cartCountVisible.setAttribute('aria-hidden', 'true');
                cartCountBubble.appendChild(cartCountVisible);
                
                const cartCountHidden = document.createElement('span');
                cartCountHidden.classList.add('visually-hidden');
                cartCountBubble.appendChild(cartCountHidden);

                cartBasket.appendChild(cartCountBubble);
            }

            // Actualizar el contador en el carrito
            const cartCountVisible = cartCountBubble.querySelector("span[aria-hidden='true']");
            const cartCountHidden = cartCountBubble.querySelector(".visually-hidden");

            cartCountVisible.textContent = itemCount;
            cartCountHidden.textContent = `${itemCount} artículos`;
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
        });
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
